import { Box } from "@mui/material";
import ImgOne from "../assets/img1.avif";
import Img2 from "../assets/img2.avif";
import Img3 from "../assets/img3.avif";
import Img4 from "../assets/img4.avif";
import Img5 from "../assets/img5.avif";
import Img6 from "../assets/img6.avif";
import Img7 from "../assets/img7.avif";
import Img8 from "../assets/img8.avif";
import ImageCard from "../components/ImageList";

const ImgListContent = () => {
  return (
    <Box
      sx={{
        display: "flex",
        overflowX: "scroll",
        maxWidth: "100%",
      }}
    >
      <ImageCard
        image={ImgOne}
        price={12334}
        rank={983}
        eth={234}
        lastSale={122}
      />
      <ImageCard
        image={ImgOne}
        price={12334}
        rank={983}
        eth={234}
        lastSale={122}
      />
      <ImageCard
        image={ImgOne}
        price={12334}
        rank={983}
        eth={234}
        lastSale={122}
      />
      <ImageCard
        image={ImgOne}
        price={12334}
        rank={983}
        eth={234}
        lastSale={122}
      />
      <ImageCard
        image={ImgOne}
        price={12334}
        rank={983}
        eth={234}
        lastSale={122}
      />
      <ImageCard
        image={ImgOne}
        price={12334}
        rank={983}
        eth={234}
        lastSale={122}
      />
      <ImageCard
        image={ImgOne}
        price={12334}
        rank={983}
        eth={234}
        lastSale={122}
      />
      <ImageCard
        image={ImgOne}
        price={12334}
        rank={983}
        eth={234}
        lastSale={122}
      />
      <ImageCard
        image={ImgOne}
        price={12334}
        rank={983}
        eth={234}
        lastSale={122}
      />
    </Box>
  );
};

export default ImgListContent;
